import React from 'react';

export const useFrontendAnalytics = () => {
  const FrontendAnalytics = React.lazy(() => import('FrontendAnalytics/FrontendAnalytics'));
  return FrontendAnalytics;
};
